import { Type } from '@angular/core';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { faCalendar as currentAppointmentIcon, faForward, faList, faUser } from '@fortawesome/pro-duotone-svg-icons';
import { faMobile as faMobileReg, faPhone as faPhoneRegular, faCircle as regularCircle } from '@fortawesome/pro-regular-svg-icons';
import { faComment, faEnvelope, faMobile, faPenSquare, faPhoneOffice, faStickyNote } from '@fortawesome/pro-solid-svg-icons';
import _ from 'lodash';
import { NonEditableFieldComponent } from 'src/app/components/utility/directory-column-edit/non-editable-field/non-editable-field.component';
import { OrgFieldColumnEditComponent } from 'src/app/components/utility/directory-column-edit/orgfield-column-edit/orgfield-column-edit.component';
import { StringColumnEditComponent } from 'src/app/components/utility/directory-column-edit/string-column-edit/string-column-edit.component';
import { StringMultilineColumnEditComponent } from 'src/app/components/utility/directory-column-edit/string-multiline-column-edit/string-multiline-column-edit.component';
import { Enum, EnumType } from 'ts-jenum';
import { BooleanOrgField, DateTimeOrgField, DirectoryEntryRemoteDto, Int32OrgField, StringOrgField } from '../../../../generated/swagger';
import { IDirectoryColumnEditComponent } from './directory-column-edit-component';

@Enum<DirectoryOrganisationUnitColumnType>('value')
export class DirectoryOrganisationUnitColumnType extends EnumType<DirectoryOrganisationUnitColumnType>() {
   static FLD_ACSHIDE = new DirectoryOrganisationUnitColumnType(
      'fld_acshide',
      'fld_acshide',
      'acshide',
      NonEditableFieldComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.acshide,
      false,
      false,
      false
   );
   static FLD_ALTNST = new DirectoryOrganisationUnitColumnType(
      'fld_altnst',
      'fld_altnst',
      'altnst',
      StringColumnEditComponent,
      faPhoneOffice,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.altnst,
      true,
      true,
      false
   );
   static FLD_CALENDAR_HOST = new DirectoryOrganisationUnitColumnType(
      'fld_calendar_host',
      'fld_calendar_host',
      'calendarHost',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => DirectoryOrganisationUnitColumnType.mapToOrgFieldObject(entry.calendarHost),
      false,
      false,
      false
   );
   static FLD_CALENDAR_TYPE = new DirectoryOrganisationUnitColumnType(
      'fld_calendar_type',
      'fld_calendar_type',
      'calendarType',
      OrgFieldColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.calendarType,
      false,
      false,
      false
   );
   static FLD_EMAIL = new DirectoryOrganisationUnitColumnType(
      'fld_email',
      'fld_email',
      'email',
      StringColumnEditComponent,
      faEnvelope,
      true,
      (entry: DirectoryEntryRemoteDto) => entry.email,
      true,
      true,
      false
   );
   static FLD_ENABLE_SIPCTI = new DirectoryOrganisationUnitColumnType(
      'fld_enable_sipcti',
      'fld_enable_sipcti',
      'enableSipcti',
      NonEditableFieldComponent,
      faPenSquare,
      true,
      (entry: DirectoryEntryRemoteDto) => entry.enableSipcti,
      false,
      false,
      false
   );
   static FLD_EXCHANGEUSER = new DirectoryOrganisationUnitColumnType(
      'fld_exchangeuser',
      'fld_exchangeuser',
      'exchangeuser',
      StringColumnEditComponent,
      faPenSquare,
      true,
      (entry: DirectoryEntryRemoteDto) => DirectoryOrganisationUnitColumnType.mapToOrgFieldObject(entry.exchangeuser),
      false,
      false,
      false
   );
   static FLD_NO_VOICEBOX = new DirectoryOrganisationUnitColumnType(
      'fld_no_voicebox',
      'fld_no_voicebox',
      'noVoicebox',
      NonEditableFieldComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.noVoicebox,
      true,
      false,
      false
   );
   static FLD_NSTBEM = new DirectoryOrganisationUnitColumnType(
      'fld_nstbem',
      'fld_nstbem',
      'nstbem',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.nstbem,
      true,
      true,
      false
   );
   static FLD_NSTMEMO = new DirectoryOrganisationUnitColumnType(
      'fld_nstmemo',
      'fld_nstmemo',
      'nstmemo',
      StringMultilineColumnEditComponent,
      faStickyNote,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.nstmemo,
      true,
      true,
      false
   );
   static FLD_NSTMEMO_2 = new DirectoryOrganisationUnitColumnType(
      'fld_nstmemo2',
      'fld_nstmemo2',
      'nstmemo2',
      StringMultilineColumnEditComponent,
      faStickyNote,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.nstmemo2,
      true,
      true,
      false
   );
   static FLD_OCSID = new DirectoryOrganisationUnitColumnType(
      'fld_ocsid',
      'fld_ocsid',
      'ocsId',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => DirectoryOrganisationUnitColumnType.mapToOrgFieldObject(entry.ocsId),
      true,
      false,
      false
   );
   static FLD_ORGCREATE = new DirectoryOrganisationUnitColumnType(
      'fld_orgcreate',
      'fld_orgcreate',
      'orgcreate',
      NonEditableFieldComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.orgcreate,
      false,
      false,
      false
   );
   static FLD_ORGFELD_00 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld00',
      'fld_orgfeld00',
      'field00',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field00,
      true,
      true,
      false
   );
   static FLD_ORGFELD_01 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld01',
      'fld_orgfeld01',
      'field01',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field01,
      true,
      true,
      false
   );
   static FLD_ORGFELD_02 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld02',
      'fld_orgfeld02',
      'field02',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field02,
      true,
      true,
      false
   );
   static FLD_ORGFELD_03 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld03',
      'fld_orgfeld03',
      'field03',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field03,
      true,
      true,
      false
   );
   static FLD_ORGFELD_04 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld04',
      'fld_orgfeld04',
      'field04',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field04,
      true,
      true,
      false
   );
   static FLD_ORGFELD_05 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld05',
      'fld_orgfeld05',
      'field05',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field05,
      true,
      true,
      false
   );
   static FLD_ORGFELD_06 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld06',
      'fld_orgfeld06',
      'field06',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field06,
      true,
      true,
      false
   );
   static FLD_ORGFELD_07 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld07',
      'fld_orgfeld07',
      'field07',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field07,
      true,
      true,
      false
   );
   static FLD_ORGFELD_08 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld08',
      'fld_orgfeld08',
      'field08',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field08,
      true,
      true,
      false
   );
   static FLD_ORGFELD_09 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld09',
      'fld_orgfeld09',
      'field09',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field09,
      true,
      true,
      false
   );
   static FLD_ORGFELD_10 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld10',
      'fld_orgfeld10',
      'field10',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field10,
      true,
      true,
      false
   );
   static FLD_ORGFELD_11 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld11',
      'fld_orgfeld11',
      'field11',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field11,
      true,
      true,
      false
   );
   static FLD_ORGFELD_12 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld12',
      'fld_orgfeld12',
      'field12',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field12,
      true,
      true,
      false
   );
   static FLD_ORGFELD_13 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld13',
      'fld_orgfeld13',
      'field13',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field13,
      true,
      true,
      false
   );
   static FLD_ORGFELD_14 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld14',
      'fld_orgfeld14',
      'field14',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field14,
      true,
      true,
      false
   );
   static FLD_ORGFELD_15 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld15',
      'fld_orgfeld15',
      'field15',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field15,
      true,
      true,
      false
   );
   static FLD_ORGFELD_16 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld16',
      'fld_orgfeld16',
      'field16',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field16,
      true,
      true,
      false
   );
   static FLD_ORGFELD_17 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld17',
      'fld_orgfeld17',
      'field17',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field17,
      true,
      true,
      false
   );
   static FLD_ORGFELD_18 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld18',
      'fld_orgfeld18',
      'field18',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field18,
      true,
      true,
      false
   );
   static FLD_ORGFELD_19 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld19',
      'fld_orgfeld19',
      'field19',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field19,
      true,
      true,
      false
   );
   static FLD_ORGFELD_20 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld20',
      'fld_orgfeld20',
      'field20',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field20,
      true,
      true,
      false
   );
   static FLD_ORGFELD_21 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld21',
      'fld_orgfeld21',
      'field21',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field21,
      true,
      true,
      false
   );
   static FLD_ORGFELD_22 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld22',
      'fld_orgfeld22',
      'field22',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field22,
      true,
      true,
      false
   );
   static FLD_ORGFELD_23 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld23',
      'fld_orgfeld23',
      'field23',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field23,
      true,
      true,
      false
   );
   static FLD_ORGFELD_24 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld24',
      'fld_orgfeld24',
      'field24',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field24,
      true,
      true,
      false
   );
   static FLD_ORGFELD_25 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld25',
      'fld_orgfeld25',
      'field25',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field25,
      true,
      true,
      false
   );
   static FLD_ORGFELD_26 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld26',
      'fld_orgfeld26',
      'field26',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field26,
      true,
      true,
      false
   );
   static FLD_ORGFELD_27 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld27',
      'fld_orgfeld27',
      'field27',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field27,
      true,
      true,
      false
   );
   static FLD_ORGFELD_28 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld28',
      'fld_orgfeld28',
      'field28',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field28,
      true,
      true,
      false
   );
   static FLD_ORGFELD_29 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld29',
      'fld_orgfeld29',
      'field29',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field29,
      true,
      true,
      false
   );
   static FLD_ORGFELD_30 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld30',
      'fld_orgfeld30',
      'field30',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field30,
      true,
      true,
      false
   );
   static FLD_ORGFELD_31 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld31',
      'fld_orgfeld31',
      'field31',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field31,
      true,
      true,
      false
   );
   static FLD_ORGFELD_32 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld32',
      'fld_orgfeld32',
      'field32',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field32,
      true,
      true,
      false
   );
   static FLD_ORGFELD_33 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld33',
      'fld_orgfeld33',
      'field33',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field33,
      true,
      true,
      false
   );
   static FLD_ORGFELD_34 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld34',
      'fld_orgfeld34',
      'field34',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field34,
      true,
      true,
      false
   );
   static FLD_ORGFELD_35 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld35',
      'fld_orgfeld35',
      'field35',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field35,
      true,
      true,
      false
   );
   static FLD_ORGFELD_36 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld36',
      'fld_orgfeld36',
      'field36',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field36,
      true,
      true,
      false
   );
   static FLD_ORGFELD_37 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld37',
      'fld_orgfeld37',
      'field37',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field37,
      true,
      true,
      false
   );
   static FLD_ORGFELD_38 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld38',
      'fld_orgfeld38',
      'field38',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field38,
      true,
      true,
      false
   );
   static FLD_ORGFELD_39 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld39',
      'fld_orgfeld39',
      'field39',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field39,
      true,
      true,
      false
   );
   static FLD_ORGFELD_40 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld40',
      'fld_orgfeld40',
      'field40',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field40,
      true,
      true,
      false
   );
   static FLD_ORGFELD_41 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld41',
      'fld_orgfeld41',
      'field41',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field41,
      true,
      true,
      false
   );
   static FLD_ORGFELD_42 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld42',
      'fld_orgfeld42',
      'field42',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field42,
      true,
      true,
      false
   );
   static FLD_ORGFELD_43 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld43',
      'fld_orgfeld43',
      'field43',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field43,
      true,
      true,
      false
   );
   static FLD_ORGFELD_44 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld44',
      'fld_orgfeld44',
      'field44',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field44,
      true,
      true,
      false
   );
   static FLD_ORGFELD_45 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld45',
      'fld_orgfeld45',
      'field45',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field45,
      true,
      true,
      false
   );
   static FLD_ORGFELD_46 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld46',
      'fld_orgfeld46',
      'field46',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field46,
      true,
      true,
      false
   );
   static FLD_ORGFELD_47 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld47',
      'fld_orgfeld47',
      'field47',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field47,
      true,
      true,
      false
   );
   static FLD_ORGFELD_48 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld48',
      'fld_orgfeld48',
      'field48',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field48,
      true,
      true,
      false
   );
   static FLD_ORGFELD_49 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld49',
      'fld_orgfeld49',
      'field49',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field49,
      true,
      true,
      false
   );
   static FLD_ORGFELD_50 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld50',
      'fld_orgfeld50',
      'field50',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field50,
      true,
      true,
      false
   );
   static FLD_ORGFELD_51 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld51',
      'fld_orgfeld51',
      'field51',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field51,
      true,
      true,
      false
   );
   static FLD_ORGFELD_52 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld52',
      'fld_orgfeld52',
      'field52',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field52,
      true,
      true,
      false
   );
   static FLD_ORGFELD_53 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld53',
      'fld_orgfeld53',
      'field53',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field53,
      true,
      true,
      false
   );
   static FLD_ORGFELD_54 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld54',
      'fld_orgfeld54',
      'field54',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field54,
      true,
      true,
      false
   );
   static FLD_ORGFELD_55 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld55',
      'fld_orgfeld55',
      'field55',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field55,
      true,
      true,
      false
   );
   static FLD_ORGFELD_56 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld56',
      'fld_orgfeld56',
      'field56',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field56,
      true,
      true,
      false
   );
   static FLD_ORGFELD_57 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld57',
      'fld_orgfeld57',
      'field57',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field57,
      true,
      true,
      false
   );
   static FLD_ORGFELD_58 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld58',
      'fld_orgfeld58',
      'field58',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field58,
      true,
      true,
      false
   );
   static FLD_ORGFELD_59 = new DirectoryOrganisationUnitColumnType(
      'fld_orgfeld59',
      'fld_orgfeld59',
      'field59',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.field59,
      true,
      true,
      false
   );
   static FLD_ORGNUM = new DirectoryOrganisationUnitColumnType(
      'fld_orgnum',
      'fld_orgnum',
      'orgnum',
      StringColumnEditComponent,
      faPhoneOffice,
      true,
      (entry: DirectoryEntryRemoteDto) => DirectoryOrganisationUnitColumnType.mapToOrgFieldObject(entry.orgnum),
      true,
      true,
      false
   );
   static FLD_ORGNAM = new DirectoryOrganisationUnitColumnType(
      'fld_orgnam',
      'fld_orgnam',
      'orgnam',
      StringColumnEditComponent,
      faUser,
      true,
      (entry: DirectoryEntryRemoteDto) => DirectoryOrganisationUnitColumnType.mapToOrgFieldObject(entry.orgnam),
      true,
      true,
      false
   );
   static FLD_ORGUPDATE = new DirectoryOrganisationUnitColumnType(
      'fld_orgupdate',
      'fld_orgupdate',
      'orgupdate',
      NonEditableFieldComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.orgupdate,
      false,
      false,
      false
   );
   static FLD_PIN = new DirectoryOrganisationUnitColumnType(
      'fld_pin',
      'fld_pin',
      'pin',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => DirectoryOrganisationUnitColumnType.mapToOrgFieldObject(entry.pin),
      true,
      false,
      false
   );
   static FLD_PRESENCE_TYPE = new DirectoryOrganisationUnitColumnType(
      'fld_presence_type',
      'fld_presence_type',
      'presenceType',
      OrgFieldColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.presenceType,
      false,
      false,
      false
   );
   static FLD_SMS = new DirectoryOrganisationUnitColumnType(
      'fld_sms',
      'fld_sms',
      'sms',
      StringColumnEditComponent,
      faMobile,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.sms,
      true,
      true,
      false
   );
   static FLD_TR_87_NUMBER = new DirectoryOrganisationUnitColumnType(
      'fld_tr87_number',
      'fld_tr87_number',
      'tr87Number',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => DirectoryOrganisationUnitColumnType.mapToOrgFieldObject(entry.tr87Number),
      false,
      false,
      false
   );
   static FLD_TRANSFER_TIMEOUT = new DirectoryOrganisationUnitColumnType(
      'fld_transfer_timeout',
      'fld_transfer_timeout',
      'transferTimeout',
      OrgFieldColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.transferTimeout,
      false,
      false,
      false
   );
   static FLD_USERSTATE = new DirectoryOrganisationUnitColumnType(
      'fld_userstate',
      'fld_userstate',
      'userstate',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.userstate,
      false,
      true,
      false
   );
   static FLD_USRNAM = new DirectoryOrganisationUnitColumnType(
      'fld_usrnam',
      'fld_usrnam',
      'usrnam',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => DirectoryOrganisationUnitColumnType.mapToOrgFieldObject(entry.usrnam),
      true,
      false,
      false
   );
   static FLD_MOBILE = new DirectoryOrganisationUnitColumnType(
      'fld_mobile',
      'fld_mobile',
      'fldMobile',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => DirectoryOrganisationUnitColumnType.mapToOrgFieldObject(entry.fldMobile),
      true,
      false,
      false
   );
   static FLD_ORG01 = new DirectoryOrganisationUnitColumnType(
      'fld_org01',
      'fld_org01',
      'org01',
      OrgFieldColumnEditComponent,
      faList,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.org01,
      false,
      false,
      true
   );
   static FLD_ORG02 = new DirectoryOrganisationUnitColumnType(
      'fld_org02',
      'fld_org02',
      'org02',
      OrgFieldColumnEditComponent,
      faList,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.org02,
      false,
      false,
      true
   );
   static FLD_ORG03 = new DirectoryOrganisationUnitColumnType(
      'fld_org03',
      'fld_org03',
      'org03',
      OrgFieldColumnEditComponent,
      faList,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.org03,
      false,
      false,
      true
   );
   static FLD_ORG04 = new DirectoryOrganisationUnitColumnType(
      'fld_org04',
      'fld_org04',
      'org04',
      OrgFieldColumnEditComponent,
      faList,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.org04,
      false,
      false,
      true
   );
   static FLD_ORG05 = new DirectoryOrganisationUnitColumnType(
      'fld_org05',
      'fld_org05',
      'org05',
      OrgFieldColumnEditComponent,
      faList,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.org05,
      false,
      false,
      true
   );
   static FLD_ORG06 = new DirectoryOrganisationUnitColumnType(
      'fld_org06',
      'fld_org06',
      'org06',
      OrgFieldColumnEditComponent,
      faList,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.org06,
      false,
      false,
      true
   );
   static FLD_ORG07 = new DirectoryOrganisationUnitColumnType(
      'fld_org07',
      'fld_org07',
      'org07',
      OrgFieldColumnEditComponent,
      faList,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.org07,
      false,
      false,
      true
   );
   static FLD_ORG08 = new DirectoryOrganisationUnitColumnType(
      'fld_org08',
      'fld_org08',
      'org08',
      OrgFieldColumnEditComponent,
      faList,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.org08,
      false,
      false,
      true
   );
   static FLD_ORG09 = new DirectoryOrganisationUnitColumnType(
      'fld_org09',
      'fld_org09',
      'org09',
      OrgFieldColumnEditComponent,
      faList,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.org09,
      false,
      false,
      true
   );
   static FLD_ORG10 = new DirectoryOrganisationUnitColumnType(
      'fld_org10',
      'fld_org10',
      'org10',
      OrgFieldColumnEditComponent,
      faList,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.org10,
      false,
      false,
      true
   );
   static FLD_ORG11 = new DirectoryOrganisationUnitColumnType(
      'fld_org11',
      'fld_org11',
      'org11',
      OrgFieldColumnEditComponent,
      faList,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.org11,
      false,
      false,
      true
   );
   static FLD_ORG12 = new DirectoryOrganisationUnitColumnType(
      'fld_org12',
      'fld_org12',
      'org12',
      OrgFieldColumnEditComponent,
      faList,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.org12,
      false,
      false,
      true
   );
   static FLD_ORG13 = new DirectoryOrganisationUnitColumnType(
      'fld_org13',
      'fld_org13',
      'org13',
      OrgFieldColumnEditComponent,
      faList,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.org13,
      false,
      false,
      true
   );
   static FLD_ORG14 = new DirectoryOrganisationUnitColumnType(
      'fld_org14',
      'fld_org14',
      'org14',
      OrgFieldColumnEditComponent,
      faList,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.org14,
      false,
      false,
      true
   );
   static FLD_ORG15 = new DirectoryOrganisationUnitColumnType(
      'fld_org15',
      'fld_org15',
      'org15',
      OrgFieldColumnEditComponent,
      faList,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.org15,
      false,
      false,
      true
   );
   static FLD_ORG16 = new DirectoryOrganisationUnitColumnType(
      'fld_org16',
      'fld_org16',
      'org16',
      OrgFieldColumnEditComponent,
      faList,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.org16,
      false,
      false,
      true
   );
   static FLD_ORG17 = new DirectoryOrganisationUnitColumnType(
      'fld_org17',
      'fld_org17',
      'org17',
      OrgFieldColumnEditComponent,
      faList,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.org17,
      false,
      false,
      true
   );
   static FLD_ORG18 = new DirectoryOrganisationUnitColumnType(
      'fld_org18',
      'fld_org18',
      'org18',
      OrgFieldColumnEditComponent,
      faList,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.org18,
      false,
      false,
      true
   );
   static FLD_ORG19 = new DirectoryOrganisationUnitColumnType(
      'fld_org19',
      'fld_org19',
      'org19',
      OrgFieldColumnEditComponent,
      faList,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.org19,
      false,
      false,
      true
   );
   static FLD_ORG20 = new DirectoryOrganisationUnitColumnType(
      'fld_org20',
      'fld_org20',
      'org20',
      OrgFieldColumnEditComponent,
      faList,
      false,
      (entry: DirectoryEntryRemoteDto) => entry.org20,
      false,
      false,
      true
   );
   static APPOINTMENTS = new DirectoryOrganisationUnitColumnType(
      'APPOINTMENTS',
      'APPOINTMENTS',
      'COLUMN_NOT_AVAILABLE',
      StringColumnEditComponent,
      currentAppointmentIcon,
      false,
      (entry: DirectoryEntryRemoteDto) => DirectoryOrganisationUnitColumnType.mapToOrgFieldObject('NOT_AVAILABLE'),
      true,
      false,
      false,
      'brick.brick_definitions.directory_browser.columns.appointments.title'
   );
   static MOBILE_STATUS = new DirectoryOrganisationUnitColumnType(
      'MOBILE_STATUS',
      'MOBILE_STATUS',
      'COLUMN_NOT_AVAILABLE',
      StringColumnEditComponent,
      faMobileReg,
      false,
      (entry: DirectoryEntryRemoteDto) => DirectoryOrganisationUnitColumnType.mapToOrgFieldObject('NOT_AVAILABLE'),
      true,
      false,
      false,
      'brick.brick_definitions.directory_browser.columns.mobile_status.title'
   );
   static LINE_STATUS = new DirectoryOrganisationUnitColumnType(
      'LINE_STATUS',
      'LINE_STATUS',
      'COLUMN_NOT_AVAILABLE',
      StringColumnEditComponent,
      faPhoneRegular,
      false,
      (entry: DirectoryEntryRemoteDto) => DirectoryOrganisationUnitColumnType.mapToOrgFieldObject('NOT_AVAILABLE'),
      true,
      false,
      false,
      'brick.brick_definitions.directory_browser.columns.line_status.title'
   );
   static PRESENCE_STATUS_NOTE = new DirectoryOrganisationUnitColumnType(
      'PRESENCE_STATUS_NOTE',
      'PRESENCE_STATUS_NOTE',
      'COLUMN_NOT_AVAILABLE',
      StringColumnEditComponent,
      faComment,
      false,
      (entry: DirectoryEntryRemoteDto) => DirectoryOrganisationUnitColumnType.mapToOrgFieldObject('NOT_AVAILABLE'),
      true,
      false,
      false,
      'brick.brick_definitions.directory_browser.columns.presence_status_note.title'
   );
   static PRESENCE_STATUS_FORWARD = new DirectoryOrganisationUnitColumnType(
      'PRESENCE_STATUS_FORWARD',
      'PRESENCE_STATUS_FORWARD',
      'COLUMN_NOT_AVAILABLE',
      StringColumnEditComponent,
      faForward,
      false,
      (entry: DirectoryEntryRemoteDto) => DirectoryOrganisationUnitColumnType.mapToOrgFieldObject('NOT_AVAILABLE'),
      true,
      false,
      false,
      'brick.brick_definitions.directory_browser.columns.presence_status_forward_destination.title'
   );
   static PRESENCE_STATUS = new DirectoryOrganisationUnitColumnType(
      'PRESENCE_STATUS',
      'PRESENCE_STATUS',
      'COLUMN_NOT_AVAILABLE',
      StringColumnEditComponent,
      regularCircle,
      false,
      (entry: DirectoryEntryRemoteDto) => DirectoryOrganisationUnitColumnType.mapToOrgFieldObject('NOT_AVAILABLE'),
      true,
      false,
      false,
      'brick.brick_definitions.directory_browser.columns.presence_status.title'
   );

   static COLUMN_NOT_AVAILABLE = new DirectoryOrganisationUnitColumnType(
      'COLUMN_NOT_AVAILABLE',
      'COLUMN_NOT_AVAILABLE',
      'COLUMN_NOT_AVAILABLE',
      StringColumnEditComponent,
      faPenSquare,
      false,
      (entry: DirectoryEntryRemoteDto) => DirectoryOrganisationUnitColumnType.mapToOrgFieldObject('NOT_AVAILABLE'),
      false,
      false,
      false
   );

   constructor(
      public value: string,
      private samwinColumnKey,
      public directoryMapValue: string,
      public editComponent: Type<IDirectoryColumnEditComponent>,
      public columnIcon: IconDefinition,
      private isDefaultVisibleValue: boolean,
      private valueMappingAction: (entry: DirectoryEntryRemoteDto) => Int32OrgField | DateTimeOrgField | BooleanOrgField | StringOrgField,
      public isValueSearchable: boolean,
      public canBeDisplayed: boolean,
      public isOrganisation: boolean,
      public translationKey: string = null
   ) {
      super();
   }

   public static valueByColumnKey(organisationUnitColumnKey: string): DirectoryOrganisationUnitColumnType {
      const typeForKey = _(DirectoryOrganisationUnitColumnType.values()).find((x) => x.samwinColumnKey === organisationUnitColumnKey);

      if (_.isNil(typeForKey)) {
         return DirectoryOrganisationUnitColumnType.COLUMN_NOT_AVAILABLE;
      }
      return typeForKey;
   }

   private static mapToOrgFieldObject(value: number | Date | boolean | string): Int32OrgField | DateTimeOrgField | BooleanOrgField | StringOrgField {
      return {
         value: value,
         isPrivate: false,
         isValueSet: value != null,
      };
   }

   public get isDefaultVisible(): boolean {
      return this.isDefaultVisibleValue;
   }

   public valueForColumnInstance(entry: DirectoryEntryRemoteDto): Int32OrgField | DateTimeOrgField | BooleanOrgField | StringOrgField {
      if (entry == null) {
         return {
            isValueSet: false,
            isPrivate: false,
            value: null,
         };
      }
      return this.valueMappingAction(entry);
   }
}
